import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { ShieldCheck } from 'lucide-react';
import { useSecurityChange } from '../hooks/useSecurityChange';
import { SecurityChangeFields, SecurityCodeField, SecurityChangeActions } from './SecurityChangeFields';

const description = (challenge, email, verifyNewEmail, password) => {
  if (challenge) return `Verification sent to ${challenge.email}. The code expires in 10 minutes.`;
  if (verifyNewEmail && !password) return 'A verification code will be sent to your new email address.';
  if (email) return `Verification is required through the current email: ${email}`;
  return 'Verify an email address before changing the password.';
};

export const SecurityChangeDialog = ({ purpose, basePath, email, onClose, onSuccess, requireCurrentPassword = false, verifyNewEmail = false }) => {
  const form = useSecurityChange({ purpose, basePath, onSuccess, requireCurrentPassword });
  const { challenge, busy, fields, set, error, request, confirm } = form;
  const password = purpose === 'password';
  return <Dialog open onOpenChange={open => { if (!open && !busy) onClose(); }}><DialogContent data-testid="customer-security-dialog" className="sm:max-w-md">
    <DialogHeader><DialogTitle><ShieldCheck className="inline mr-2 text-emerald-700" size={20} />Change {password ? 'password' : 'email'}</DialogTitle><DialogDescription data-testid="security-description">{description(challenge, email, verifyNewEmail, password)}</DialogDescription></DialogHeader>
    <form onSubmit={challenge ? confirm : request} className="space-y-4" data-testid="customer-security-form">
      {challenge ? <SecurityCodeField code={fields.code} set={set} /> : <SecurityChangeFields password={password} requireCurrentPassword={requireCurrentPassword} fields={fields} set={set} />}
      {error && <p role="alert" data-testid="security-error" className="text-sm text-rose-700">{error}</p>}
      <SecurityChangeActions {...form} />
    </form>
  </DialogContent></Dialog>;
};